import React from "react";

export default class Pack extends React.Component {
  render() {
      const { title, clist } = this.props;
    return (
      
        <div className="channel-holder">
            <h3 className="bouquet-heading">{title}</h3>
          <div className="channel-list">
              {
                  clist.map((ch, index) => (
                      <Channel 
                        key={index} 
                        cclass={ch.cclass}
                        cname={ch.cname}
                        />
                  )) 
              }
          </div>
        </div>
    );
  }
}

const Channel = ({ cclass, cname }) => (
  <div className={`channel ${cclass}`}>{cname}</div>
);
